import React from 'react';

import TaskDragIcon from '../../../components/icons/light/medium/jsx/task-drag';

import './TaskListDragHandle.scss';

const TaskListDragHandle: React.FC = () => (
    <div className="TaskListDragHandle">
        <TaskDragIcon />
    </div>
);

export default TaskListDragHandle;
